import { EnvironmentDefinition } from '../../models/environment-definition';
import { createStringIdAdapter } from './common/string-id-adapter';

export const environmentDefinitionAdapter = createStringIdAdapter<EnvironmentDefinition>();
